exports.components = {
  "component---src-pages-delivery-jsx": () => import("./../../../src/pages/delivery.jsx" /* webpackChunkName: "component---src-pages-delivery-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-rent-jsx": () => import("./../../../src/pages/rent.jsx" /* webpackChunkName: "component---src-pages-rent-jsx" */),
  "component---src-pages-routes-jsx": () => import("./../../../src/pages/routes.jsx" /* webpackChunkName: "component---src-pages-routes-jsx" */)
}

